/** @format */

import axios from "axios";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

import Manbalar from "./cards/Manbalar";
import Balanslar from "./cards/Balanslar";
import Chart2 from "../../components/Chart2";
import Chart5 from "../../components/Chart5";
import Chart10 from "../../components/Chart10";
import Chart11 from "../../components/Chart11";
import SugorishCart from "./cards/SugorishCart";
import { header } from "../../../../components/api/Header";
import ErrorBoundary from "../../../../components/ErrorBoundry";
import { getEnv } from "../../../../lib/env";

const Navoiy = ({ date }) => {
  const [data, setData] = useState({});
  const districts = useSelector((state) => state.data.districts);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/dashboard/charts?date=${date}`,
          header()
        );
        setData(res.data || {});
      } catch (e) {
        console.log("Xato", e);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='dashboard'>
      <div className='mgk-box and navoiy'>
        <Balanslar date={date} a={1} s={0} z={1} />
        <SugorishCart />
      </div>

      <div className='data-content card3 mt-3'>
        <div className='card statistic-card bosh-sahifa-barchart px-2'>
          <ErrorBoundary>
            <Chart11 districts={districts} />
          </ErrorBoundary>
        </div>

        <div className='card statistic-card bosh-sahifa-barchart px-2'>
          <ErrorBoundary>
            <Chart10 districts={districts} />
          </ErrorBoundary>
        </div>
      </div>

      <Manbalar date={date} singlerow={0} region='and' />

      <div className='jizz'>
        <div className='row'>
          <div className='col-md-6'>
            <Chart2 data={data["r"]} />
          </div>

          <div className='col-md-6'>
            <Chart5 data={data["z"]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navoiy;
